MS = window.MS || {};

(function($) {
  MS.productlanding_accordion = {
    selectors: {
      module: 'ms-pl-accordion',
      supportImages: 'ms-pl-accordion__images',
      contentPanel: 'ms-pl-accordion__content',
      toggleClass: 'ms-pl-accordion__item-toggle',
      toggleIcon: 'ms-pl-accordion__item-icon',
      itemClass: 'ms-pl-accordion__item',
      activeItemClass: 'ms-pl-accordion__item--open',
      itemCopy: 'ms-pl-accordion__item-copy',
      itemsContainer: 'ms-pl-accordion__list',
      ctaClass: 'ms-pl-accordion__cta',
      ctaActiveClass: 'ms-pl-accordion__cta--expanded',
      ctaTextClass: 'ms-pl-accordion__cta-text',
      collapse: 'icon-collapse',
      expand: 'icon-expand',
      maxShown: 6,
      excess: []
    },
    init: function() {
      var _self = this;
      var isModulePresent = $('.' + this.selectors.module).length;
      if (!isModulePresent) { return; }

      this.hideExcess();
      this.toggleClick();
      this.ctaClick();

      var items = $('.' + this.selectors.itemClass);

      if (items.length <= this.selectors.maxShown) {
        $('.' + _self.selectors.ctaClass).hide();
      }

      $(window).on("load", function() {
        _self.setModuleHeight();
      });

      $(window).on("resize",  utilities.debounce( function() {
        _self.setModuleHeight();
       }, 200));

    },
    setModuleHeight: function() {
      var isDesktop = $(window).width() >= 1200,
        $module = $('.' + this.selectors.module),
        $images = $('.' + this.selectors.supportImages),
        imagesHeight = $images.height() - 20;

      if(!isDesktop) {
        $module.css('min-height', 'initial');
        return;
      }

      $module.css('min-height', imagesHeight + 'px');

    },
    hideExcess: function() {
      var items = $('.' + this.selectors.itemClass);

      if (items.length > this.selectors.maxShown) {
        for (var i = items.length; i >= this.selectors.maxShown; i--) {
          $(items[i]).hide();
        }
      }
    },
    toggleClick: function() {
      var _self = this;

      $('.' + this.selectors.itemsContainer).on(
        'click',
        '.' + this.selectors.toggleClass,
        function(e) {
          $(e.target)
            .parents('.' + _self.selectors.itemClass)
            .toggleClass(_self.selectors.activeItemClass);

          // Change icon
          var targetEl = $(e.target)
            .children()
            .children('.' + _self.selectors.toggleIcon);

          if (targetEl.hasClass(_self.selectors.expand)) {
            targetEl[0].classList.remove(_self.selectors.expand);
            targetEl[0].classList.add(_self.selectors.collapse);
          } else {
            targetEl[0].classList.remove(_self.selectors.collapse);
            targetEl[0].classList.add(_self.selectors.expand);
          }

          // Toggle Selected
          $(e.target)
            .siblings('.' + _self.selectors.itemCopy)
            .slideToggle();
        }
      );
    },
    ctaClick: function() {
      var _self = this;

      $('.' + this.selectors.ctaClass).on('click', function(e) {
        $(e.target).toggleClass(_self.selectors.ctaActiveClass);

        if ($(e.target).hasClass(_self.selectors.ctaActiveClass)) {
          var items = $('.' + _self.selectors.itemClass);

          for (var i = _self.selectors.maxShown; i <= items.length; i++) {
            $(items[i]).show('fast');
          }

          $('.' + _self.selectors.ctaTextClass).text('Show less FAQs');
        } else {
          var items = $('.' + _self.selectors.itemClass);

          if (items.length > _self.selectors.maxShown) {
            for (var i = items.length; i >= _self.selectors.maxShown; i--) {
              $(items[i]).hide('fast');
            }
          }

          $('.' + _self.selectors.ctaTextClass).text('Show all FAQs');
        }
      });
    }
  };
})(jQuery);
